import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import posthog from 'posthog-js';

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

if (posthogKey && posthogHost) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    person_profiles: 'identified_only',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_heatmaps: false,
    disable_session_recording: true,
    disable_compression: true,
  });
} else {
  // Helps in local dev if env vars are missing/typo'd
  console.warn('PostHog not initialized: missing REACT_APP__POSTHOG_KEY and/or REACT_APP__POSTHOG_HOST');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
